<script>
  import converterNumero from '~js/converter-moeda';
  
  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        
      }
    },
    computed: {
      totalSolicitado() {
        return this.solicitacao.despesasViajem.reduce((total, despesa) => {
          return total + converterNumero.paraDolar(despesa.valorSolicitado);
        }, 0);
      },
      totalDeclarado() {
        let total = 0;
        
        this.solicitacao.despesasViajem.map(despesa => {
          total += despesa.rateios.reduce((somatorio, rateio) => {
            return somatorio + converterNumero.paraDolar(rateio.valor);
          }, 0);
        });
        
        return total;
      },
      totalAprovado() {
        let total = 0;
        
        this.solicitacao.despesasViajem.map(despesa => {
          total += despesa.rateios.reduce((somatorio, rateio) => {
            return somatorio + rateio.valorValidado;
          }, 0);
        });
        
        return total;
      },
    }
  }
</script>

<template>
  <div>
    
    <div class="row">
      <h4 class="col-md-12">Declaração de despesas</h4>
    </div>
    
    <div class="row">
      
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Total solicitado</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="totalSolicitado | formatarNumero"
            disabled>
        </div>
      </div>
      
      <div class="col-md-1">
        <label class="control-label hidden-md hidden-sm hidden-xs">&nbsp;</label>

        <div class="form-control text-center no-borders">-</div>
      </div>
      
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Total de despesas declaradas</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="totalDeclarado | formatarNumero"
            disabled>
        </div>
      </div>

      <div class="col-md-1">
        <label class="control-label  hidden-md hidden-sm hidden-xs">&nbsp;</label>
        
        <div class="form-control text-center no-borders">=</div>
      </div>
      
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Diferença</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="(totalSolicitado - totalDeclarado) | formatarNumero"
            disabled>
        </div>
      </div>
      
    </div>
    
    <div class="row">
      
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Total solicitado</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="totalSolicitado | formatarNumero"
            disabled>
        </div>
      </div>
      
      <div class="col-md-1">
        <label class="control-label hidden-md hidden-sm hidden-xs">&nbsp;</label>

        <div class="form-control text-center no-borders">-</div>
      </div>
      
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Total de despesas aprovadas</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="totalAprovado | formatarNumero"
            disabled>
        </div>
      </div>

      <div class="col-md-1">
        <label class="control-label hidden-md hidden-sm hidden-xs">&nbsp;</label>
        
        <div class="form-control text-center no-borders">=</div>
      </div>
      
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Diferença</label>

          <input 
            class="form-control text-right"
            type="text"
            :value="(totalSolicitado - totalAprovado) | formatarNumero"
            disabled>
        </div>
      </div>
      
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <p class="text-danger"><i>* Enquanto despesa aprovada for igual a zero, significa que a fundação ainda não analisou a prestação.</i></p>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/Totalizador.vue